import { render, staticRenderFns } from "./participates.vue?vue&type=template&id=3d88afb3&scoped=true"
import script from "./participates.vue?vue&type=script&lang=js"
export * from "./participates.vue?vue&type=script&lang=js"
import style0 from "./participates.vue?vue&type=style&index=0&id=3d88afb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88afb3",
  null
  
)

export default component.exports